module.exports = __webpack_public_path__ + "img/flag2.c19d9cbd.png";